import React, {useState} from 'react';
import {Store} from '../../models/store.model';
import {AppCardTitle, AppSmallText, AppTitle, AppLabelText, AppSectionTitle} from '../../../../constants';
import {User, Phone, Copy, Check} from 'lucide-react';
import {useNotification} from '../../../../Services/useNotification';

interface StoreBasicInfoProps {
  store: Store;
}

export const StoreBasicInfo: React.FC<StoreBasicInfoProps> = ({store}) => {
  const {success: showSuccess, error: showError} = useNotification();
  const [phoneCopied, setPhoneCopied] = useState(false);

  const copyPhoneNumber = async () => {
    try {
      await navigator.clipboard.writeText(store.phoneNumber);
      setPhoneCopied(true);
      showSuccess('تم نسخ رقم الهاتف بنجاح');

      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setPhoneCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy phone number: ', error);
      showError('فشل في نسخ رقم الهاتف');
    }
  };

  return (
    <div className="space-y-4">
      <AppCardTitle className="text-gray-900 border-b pb-2">المعلومات الأساسية</AppCardTitle>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-4 rounded-lg border border-brand-200">
          <div className="flex items-center gap-3 mb-2">
            <User className="w-5 h-5 text-brand-600" />
            <AppSmallText className="text-brand-700 font-medium">مدير المتجر</AppSmallText>
          </div>
          <AppTitle className="text-brand-900">{store.managerName}</AppTitle>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-4 rounded-lg border border-purple-200">
          <div className="flex items-center gap-3 mb-2">
            <User className="w-5 h-5 text-purple-600" />
            <AppSmallText className="text-purple-700 font-medium">مطور التسويق</AppSmallText>
          </div>
          <AppTitle className="text-purple-900">{store.developerName}</AppTitle>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-green-100 p-4 rounded-lg border border-green-200">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-green-600" />
              <AppLabelText className="text-green-700 font-medium">رقم الهاتف</AppLabelText>
            </div>
            <button
              onClick={copyPhoneNumber}
              className="flex items-center gap-1 px-2 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 transition-colors"
              title="نسخ رقم الهاتف"
            >
              {phoneCopied ? (
                <>
                  <Check className="w-3 h-3" />
                  <span>تم النسخ</span>
                </>
              ) : (
                <>
                  <Copy className="w-3 h-3" />
                  <span>نسخ</span>
                </>
              )}
            </button>
          </div>
          <AppSectionTitle className="font-bold text-green-900" dir="ltr">{store.phoneNumber}</AppSectionTitle>
        </div>
      </div>
    </div>
  );
};


